export default "__VITE_ASSET__B46Vul16__"